import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute, Outlet } from '@tanstack/react-router';

export const remoteManagementRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'remote-management',
  component: Outlet,
  beforeLoad: ({ context }) => {
    if (!context.auth.userIsAdmin()) {
      throw new Error('User is not an admin');
    }
  },
  errorComponent: React.lazy(async () => await import('@/modules/core/pages/not-allowed')),
});
